import { render, staticRenderFns } from "./DumpsterPrice.vue?vue&type=template&id=955f5f8e&scoped=true&v-cloak=true&v-if=dumpster&"
import script from "./DumpsterPrice.vue?vue&type=script&lang=js&"
export * from "./DumpsterPrice.vue?vue&type=script&lang=js&"
import style0 from "./DumpsterPrice.vue?vue&type=style&index=0&id=955f5f8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955f5f8e",
  null
  
)

export default component.exports